import PropTypes from 'prop-types';
import React from 'react';
import { instructorResourceDefinition } from '../resources/instructorResourceDefinition';
import connect from './connect';
import { uploadMaterial } from '../actions/material';
import { createLoader } from '../loader';
import { setContent, clearContent } from 'actions/manage_content';
import { ALLOWED_UPLOAD_TYPES } from '../const';

import UploadDisplay from './upload_material_dialog.ui.jsx';

class UploadMaterialsDialog extends React.Component {
    static displayName = 'UploadMaterialsDialog';

    static propTypes = {
        description: PropTypes.string,
        onClose: PropTypes.func,
        sections: PropTypes.array,
        selectedSections: PropTypes.array,
        setContent: PropTypes.func.isRequired,
        clearContent: PropTypes.func.isRequired,
        terms: PropTypes.array,
        title: PropTypes.string,
        tos: PropTypes.bool,
        uploadMaterial: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            validationErrors: {},
        };
    }

    onSave = fileElement => {
        const { selectedSections, title, description, tos } = this.props;
        if (this.validate(fileElement)) {
            this.props.onClose();
            this.props.uploadMaterial({
                fileElement,
                sections: selectedSections,
                title,
                description,
                tos,
            });
        }
    };

    validate(fileElement) {
        const validationErrors = {};

        if (fileElement.files.length === 0) {
            validationErrors.file = 'Select a valid resource to upload.';
        }

        if (fileElement.files.length !== 0) {
            const extension = fileElement.files[0].name
                .split('.')
                .pop()
                .toLowerCase();

            // provide explanation of how to hanlde epub files.
            // eventually we will have this in the list of allowable types
            // but for now we need to provide a ux workaround
            if (extension === 'epub') {
                validationErrors.file = (
                    <span>
                        Epub files are not yet supported by the Unizin Engage
                        uploader. Please send an email to{' '}
                        <a href="mailto:support@unizin.org?subject=Engage%20Epub%20Upload">
                            support@unizin.org
                        </a>{' '}
                        with your attached epub file and our support term will
                        assist you in delivering your file.'
                    </span>
                );
            }

            // if the file is not an epub, it's invalid if it's
            // not of a supported type
            if (
                !ALLOWED_UPLOAD_TYPES.includes(extension) &&
                extension !== 'epub'
            ) {
                validationErrors.file = (
                    <div>
                        <p>
                            You’re attempting to upload an unsupported file
                            extension. Please see the list below for the
                            supported file extensions:
                        </p>
                        <p>{ALLOWED_UPLOAD_TYPES.join(', ')}</p>
                    </div>
                );
            }
        }

        if (!this.props.title.trim()) {
            validationErrors.title = 'Include a title for this resource.';
        }

        if (this.props.selectedSections.length === 0) {
            validationErrors.sections =
                'Assign this resource to one or more areas.';
        }

        if (!this.props.tos) {
            validationErrors.tos =
                'You must agree to the Terms of Service before uploading a resource.';
        }

        this.setState({ validationErrors });
        return Object.keys(validationErrors).length === 0;
    }

    render() {
        const {
            clearContent,
            description,
            onClose,
            sections,
            selectedSections,
            setContent,
            terms,
            title,
            tos,
        } = this.props;
        const { validationErrors } = this.state;
        return (
            <UploadDisplay
                validationErrors={validationErrors}
                selectedSections={selectedSections}
                title={title}
                description={description}
                tos={tos}
                setContent={setContent}
                onSave={this.onSave}
                onClose={onClose}
                sections={sections}
                terms={terms}
                clearContent={clearContent}
            />
        );
    }
}

const LoaderView = createLoader({
    component: UploadMaterialsDialog,
    resources: instructorResourceDefinition(),
});

export default connect(
    state => {
        return {
            rootState: state,
            ...state.manage_content,
        };
    },
    {
        uploadMaterial,
        setContent,
        clearContent,
    }
)(LoaderView);



// WEBPACK FOOTER //
// ./src/components/upload_material_dialog.jsx